import './Login.css';
import React, { useState, useContext, useEffect } from "react";
import { UserContext } from "../../context/UserContext";
import ErrorMessage from "../../common/ErrorMessage/ErrorMessage";
import {Link, useNavigate} from 'react-router-dom';
import { BASE_URL } from '../../baseUrl';

function Login() {
  
    //This code helps to scroll to the top when the screen is open
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  //const [, setToken] = useContext(UserContext);
  const [, setLogin] = useContext(UserContext);

  const submitLogin = async () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: JSON.stringify(
        `grant_type=&username=${email}&password=${password}&scope=&client_id=&client_secret='`
      ),
    };
  
    const response = await fetch(BASE_URL + "/api/token", requestOptions);
  
    if (!response.ok) {
      // If the response is not okay, handle the error
      const errorText = await response.text(); // Get the error response as text
      try {
        const errorData = JSON.parse(errorText); // Try to parse the text as JSON
        setErrorMessage(errorData.detail);
      } catch (error) {
        console.error("Error parsing error response:", error);
      }
    } else {
      // Parse the successful response body
      const data = await response.text(); // Get the response as text
      try {
        const parsedData = JSON.parse(data); // Try to parse the text as JSON
        //console.log('-----parseData------')
        //console.log(parsedData)
        const bodyData = JSON.parse(parsedData.body); // The body itself is a stringified JSON, parse it too
        //console.log('-----bodyData------')
        //console.log(bodyData);
        setLogin({ token: bodyData.access_token, isLoggedIn: true });
        localStorage.setItem('tkn_2050', bodyData.access_token);
        navigate('/');
      } catch (error) {
        console.error("Error parsing success response:", error);
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    submitLogin();
  };

  return (
    
    <div>
    <section>
      <div className="form-box">
        <div className="form-value">
          <form action=""  onSubmit={handleSubmit}>
            <div className="inputbox">
              <ion-icon name="mail-outline"></ion-icon>
              <input 
                    type="email"
                    placeholder="Enter email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)} 
                    required 
              />           
            </div>
            <div className="inputbox">
              <ion-icon name="lock-closed-outline"></ion-icon>
              <input 
                    type="password"
                    placeholder="Enter password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)} 
                    required 
              /> 
            </div>

            <div className="forget">
            <label className="custom-checkbox">
                  <input type="checkbox" />
                  <span className="checkbox-mark"></span>
                  <span className="checkbox-label">Remember Me</span>
                  <a href="#" style={{ fontSize: '11px', marginLeft: '2.5cm' }}>Forgot Password</a>
                </label>
            </div>
            
            {errorMessage && ( //Check if error message exists
            <div className="error-message" style={{backgroundColor: 'white', fontStyle: 'oblique'}}>
              {errorMessage}
            </div>
            )}
            <div message={errorMessage} />
            <br />
            <button className="btn-login" type="submit">
            Login
            </button>

            <div className="register">
              <p>Do not have an account?   ---- <Link to="/sign-up">Sign Up</Link></p>
            </div>
          </form>
        </div>
      </div>
    </section>
    </div>
  );
}

export default Login;


